interface SidebarBodyProps {
  children: React.ReactNode
}

export default function SidebarBody({ children }: SidebarBodyProps) {
  return (
    <div className="flex flex-1 flex-col gap-y-4">
      {children}
    </div>
  )
} 